import { render, staticRenderFns } from "./ModalAssignConsultant.vue?vue&type=template&id=49222134&scoped=true"
import script from "./ModalAssignConsultant.vue?vue&type=script&lang=js"
export * from "./ModalAssignConsultant.vue?vue&type=script&lang=js"
import style0 from "./ModalAssignConsultant.vue?vue&type=style&index=0&id=49222134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49222134",
  null
  
)

export default component.exports